export default __webpack_public_path__ + "static/media/stufflogo.a2319aec.png";